tooltip = exports

tooltip.create = (el, e = null, options = {}) ->

    el = $(el) if el not instanceof jQuery

    # Don't create tooltips on the map
    if el.parents().is('#map_canvas')
        return false

    if el.is('[data-original-title]')
        # This is not be a perfect check, but if there is already a jQuery
        # object binding, don't recreate the tooltip. The binding looks like:
        #
        # jQuery981209398450309143972: 3984
        for k, v of el[0]
            if k.indexOf('jQuery') is 0
                kStr = k.replace('jQuery', '')
                vStr = v.toString()

                # WARNING: NEVER use regexes to test if values are numeric.
                # This is ONLY an acceptable solution here because the native
                # parseInt/parseFloat functions fail us (not enough precision)
                # and we know we are looking for only positive integers with no
                # unusual notation.
                if kStr.match(/[0-9]+/)[0] is kStr and vStr.match(/[0-9]+/)[0] is vStr
                    return

    # set and apply the defaults
    defaults = # {}
        delay:
            show: 500
            hide: 200
    if el.parents().is('.scrolling-table tbody>tr:first-child')
        defaults.placement = 'bottom'
    options = $.extend defaults, options

    # create the tooltip
    el.tooltip options

    # If we passed in an event that we are creating the tooltip on, we want
    # to re-fire it so the tooltip will be shown right away
    if e?
        e.stopPropagation()
        el.trigger(e.type)
